var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("gg-modal", {
    attrs: {
      "is-active": _vm.dialog
    },
    on: {
      close: _vm.close
    },
    scopedSlots: _vm._u([
      {
        key: "toolbar",
        fn: function fn() {
          return [_vm._v("Change Account Quota")]
        },
        proxy: true
      },
      {
        key: "body",
        fn: function fn() {
          return [
            _c(
              "v-row",
              [
                _c(
                  "v-col",
                  {
                    attrs: {
                      cols: "12"
                    }
                  },
                  [
                    _c("p", [
                      _vm._v("Change account "),
                      _c("strong", [_vm._v(_vm._s(_vm.account.user))]),
                      _vm._v(" quota.")
                    ])
                  ]
                ),
                _c(
                  "v-col",
                  {
                    attrs: {
                      cols: "10"
                    }
                  },
                  [
                    _c("v-slider", {
                      attrs: {
                        color: "primary",
                        min: "0",
                        max: "10240",
                        label: "Quota",
                        step: "8",
                        hint:
                          "Set to 0 to grant the account unlimited disk space."
                      },
                      model: {
                        value: _vm.quota,
                        callback: function callback($$v) {
                          _vm.quota = $$v
                        },
                        expression: "quota"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "v-col",
                  {
                    staticClass: "px-0",
                    attrs: {
                      cols: "2"
                    }
                  },
                  [_c("span", [_vm._v(_vm._s(_vm.quota) + " MB")])]
                )
              ],
              1
            )
          ]
        },
        proxy: true
      },
      {
        key: "actions",
        fn: function fn() {
          return [
            _c(
              "gg-btn",
              {
                attrs: {
                  secondary: ""
                },
                on: {
                  click: _vm.close
                }
              },
              [_vm._v("Cancel")]
            ),
            _c(
              "gg-btn",
              {
                attrs: {
                  primary: "",
                  loading: _vm.loading
                },
                on: {
                  click: _vm.changeQuota
                }
              },
              [_vm._v("Change Quota")]
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }